import { render, staticRenderFns } from "./blackModal.vue?vue&type=template&id=5f980e06&scoped=true"
import script from "./blackModal.vue?vue&type=script&lang=js"
export * from "./blackModal.vue?vue&type=script&lang=js"
import style0 from "./blackModal.vue?vue&type=style&index=0&id=5f980e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f980e06",
  null
  
)

export default component.exports